import React from 'react';
import { Move, Save } from 'lucide-react';

const ControlPanel = ({ show, controls, slideInfo }) => {
    if (!show) return null;
    const {
        brightness, setBrightness,
        brightnessMask, setBrightnessMask,
        redThreshold, setRedThreshold,
        greenThreshold, setGreenThreshold,
        contourShift, isAligning,
        startAlignment, cancelAlignment, handleSaveShift,
        entropyThreshold, setEntropyThreshold,
    } = controls;

    return (
        <div className="relative bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm 
                   rounded-lg shadow-lg p-4 z-20 max-w-xs
                    ">
            {!isAligning && (
                <>

                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mt-2 mb-2 border-b dark:border-gray-700 pb-2">Controls</h3>
                    <div className="space-y-3 text-sm">
                        <div className="space-y-3 text-sm">
                            {slideInfo && (
                                <>
                                    <div className="space-y-1">
                                        <label className="font-medium flex justify-between items-center dark:text-gray-300"><span>Brightness Slide</span><span className="text-xs font-normal bg-gray-200 dark:bg-gray-600 px-1.5 py-0.5 rounded">{brightness.toFixed(1)}x</span></label>
                                        <input type="range" min="0.5" max="5.5" step="0.5" value={brightness} onChange={(e) => setBrightness(parseFloat(e.target.value))} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500" />
                                    </div>
                                    <div className="space-y-1">
                                        <label className="font-medium flex justify-between items-center dark:text-gray-300"><span>Opacity Contours</span><span className="text-xs font-normal bg-gray-200 dark:bg-gray-600 px-1.5 py-0.5 rounded">{brightnessMask.toFixed(1)}x</span></label>
                                        <input type="range" min="0" max="1" step="0.1" value={brightnessMask} onChange={(e) => setBrightnessMask(parseFloat(e.target.value))} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500" />
                                    </div>
                                </>
                            )}

                            <div className="space-y-1">
                                <label className="font-medium flex justify-between items-center"><span style={{ color: '#CE4760' }}>Red max / Blue mean Threshold</span><span className="text-xs font-normal bg-gray-200 dark:bg-gray-600 px-1.5 py-0.5 rounded">{redThreshold}</span></label>
                                <input type="range" min="0.1" max="5" step="0.1" value={redThreshold} onChange={(e) => setRedThreshold(parseFloat(e.target.value))} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer" style={{ accentColor: '#CE4760' }} />
                            </div>
                            <div className="space-y-1">
                                <label className="font-medium flex items-center text-wrap"><span style={{ color: '#65A36A' }}>( Green max - Green min ) / Blue mean Threshold</span><span className="text-xs font-normal bg-gray-200 dark:bg-gray-600 px-1.5 py-0.5 rounded">{greenThreshold}</span></label>
                                <input type="range" min="0.1" max="5" step="0.1" value={greenThreshold} onChange={(e) => setGreenThreshold(parseFloat(e.target.value))} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer" style={{ accentColor: '#65A36A' }} />
                            </div>
                            <div className="p-2">
                                <label htmlFor="entropy" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Entropy Threshold: {entropyThreshold.toFixed(2)}
                                </label>
                                <input
                                    id="entropy"
                                    type="range"
                                    min="0"
                                    max="8"
                                    step="0.1"
                                    value={entropyThreshold}
                                    onChange={(e) => setEntropyThreshold(parseFloat(e.target.value))}
                                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                                />
                            </div>

                        </div>
                    </div>

                </>
            )}

            {slideInfo && (
                <div className="space-y-2 pt-2 border-t dark:border-gray-700 mt-2">
                    <label className="font-medium flex justify-between items-center dark:text-gray-300">Contour Alignment</label>
                    <div className="text-xs text-gray-500 dark:text-gray-400">X: {contourShift.x.toFixed(2)}, Y: {contourShift.y.toFixed(2)}</div>
                    {!isAligning ? (
                        <button onClick={startAlignment} className="w-full flex items-center justify-center space-x-2 px-3 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600  dark:bg-slate-700 dark:hover:bg-slate-950 dark:text-slate-200  transition-colors">
                            <Move size={16} /> <span>Align Labels</span>
                        </button>
                    ) : (
                        <>
                            <div className='flex flex-row space-x-2 items-center justify-center'>
                                <button onClick={handleSaveShift} className="flex items-center justify-center space-x-2 px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors">
                                    <Save size={16} /> <span>Save Alignment</span>
                                </button>
                                <button onClick={cancelAlignment} className="flex  items-center justify-center space-x-2 px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors">
                                    <span>Cancel</span>
                                </button>

                            </div>
                        </>

                    )}
                </div>
            )}

        </div>
    );
};

export default ControlPanel;